var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('template-one',{attrs:{"data":_vm.one,"fontBg":"01"}}),_c('template-two',{attrs:{"data":_vm.two,"fontBg":"02"}}),_c('template-three',{attrs:{"data":_vm.three,"fontBg":"03"}}),_c('template-two',{attrs:{"data":_vm.four,"fontBg":"04","bgColor":"#FFFFFF"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }